import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';

export default class Testimonials {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if ($('.testimonials__slideItem').length > 1) {
			this.swiper = new Swiper('.testimonials__slideActive', {
				loop: true,
				modules: [Autoplay, Navigation],
				slidesPerView: 1,
				spaceBetween: 0,
				speed: 600,
				autoplay: {
					delay: 6000,
					disableOnInteraction: false
				},
				navigation: {
					nextEl: '.testimonials__slideArrowNext',
					prevEl: '.testimonials__slideArrowPrev'
				},
				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 20
					},
					768: {
						slidesPerView: 1.5,
						spaceBetween: 30
					},
					950: {
						slidesPerView: 2.5,
						spaceBetween: 30
					}
				}
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
